import { CommentsInput, CompanyDataInputs, InstallationsInputs } from './steps/types'

export type GenericFormInput = CompanyDataInputs | InstallationsInputs[] | CommentsInput

export type ProducerContactFormInput = {
  [ProducerContactSteps.COMPANY_DATA]?: CompanyDataInputs
  [ProducerContactSteps.INSTALLATIONS]?: InstallationsInputs[]
  [ProducerContactSteps.COMMENTS]?: CommentsInput
}

export enum ProducerContactSteps {
  COMPANY_DATA = 'companyData',
  INSTALLATIONS = 'installations',
  COMMENTS = 'comments',
  CONFIRMATION = 'confirmation'
}
